<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 20">
    <path
      d="M19.7,17.73V2.26h2.22l3.1,3v9.61l-3.1,2.91Z"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M1,5.45V2.26H16.7V17.74H1V14.55A4.66,4.66,0,0,0,4.64,10,4.66,4.66,0,0,0,1,5.45Z"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>
